import React from 'react'
import Header from '../Components/Header'
import Footer from '../Components/Footer'
import Homebody from './Homebody'

function Home() {
  return (
    <div>
        <Header/>
      <Homebody/>
    <Footer/>
    </div>
  )
}

export default Home